import store from '@/store';

export const notify = (
  { title, body },
  ackNotification = false,
  notificationType = 'ackcall',
) => {
  const { notifyVoiceConnectionLost } =
    store.state.attendance.Attendance.agentPreferences;

  if (Notification.permission === 'granted') {
    if (
      (notificationType == 'voiceWebrtcProblem' ||
        notificationType == 'voiceWebrtcReconnectionSuccess') &&
      !notifyVoiceConnectionLost
    ) {
      return;
    }

    const icons = {
      ackcall:
        process.env.NODE_ENV === 'production'
          ? '/agent/static/chiwe.png'
          : '/static/chiwe.png',
      colleagues:
        process.env.NODE_ENV === 'production'
          ? '/agent/static/human-greeting-variant.png'
          : '/static/human-greeting-variant.png',
      voiceWebrtcProblem:
        process.env.NODE_ENV === 'production'
          ? '/agent/static/voice-webrtc-problem.png'
          : '/static/voice-webrtc-problem.png',
      voiceWebrtcReconnectionSuccess:
        process.env.NODE_ENV === 'production'
          ? '/agent/static/broadcast.png'
          : '/static/broadcast.png',
      whatsapp:
        process.env.NODE_ENV === 'production'
          ? '/agent/static/whatsapp.png'
          : '/static/whatsapp.png',
      chat:
        process.env.NODE_ENV === 'production'
          ? '/agent/static/chat.png'
          : '/static/chat.png',
    };

    const icon = icons[notificationType];

    const options = {
      body,
      dir: 'ltr',
      icon,
      requireInteraction: ackNotification,
    };

    const notification = new Notification(title, options);
    notification.onclick = (event) => {
      event.preventDefault();
      window.focus();
    };

    if (ackNotification) {
      notification.onshow = function () {
        setTimeout(() => {
          notification.close();
        }, 15000);
      };
    }
  }

  requestPermissionNotificaiton();
};

export const requestPermissionNotificaiton = () => {
  if (Notification.permission !== 'granted') {
    Notification.requestPermission()
      .then()
      .catch((err) => console.log(err));
  }
};
